<template>
<div class="dept-notification-edit">
  <el-form ref="editForm" label-width="130px" :model="editJson" :rules="rules">
    <el-form-item class="flex-form-item" label="部门" prop="departNo">
      <DeptSelect v-model="editJson.departNo" />
    </el-form-item>
    <el-form-item label="人员" prop="wkNos" class="select-form-item">
      <el-select 
        v-model="editJson.wkNos" ref="selecter"
        multiple :collapse-tags="collapse"
        disabled max-height="200"
        :placeholder="placeholder" class="multiple-person-select" clearable :popper-append-to-body="appendBody"
      >
        <el-option v-for="item in initWkList" :label="item.wkName" :value="item.wkNo" :key="item.wkNo"></el-option>
      </el-select>
      <el-button class="select-btn" type="primary" @click="showUserEdit">选择</el-button>
    </el-form-item>
    <el-form-item label="消息提醒接收人" prop="recipientWkNos" class="select-form-item">
      <el-select 
        v-model="editJson.recipientWkNos" ref="selecter"
        multiple :collapse-tags="collapse"
        disabled max-height="200"
        :placeholder="placeholder" class="multiple-person-select" clearable :popper-append-to-body="appendBody"
      >
        <el-option v-for="item in initRecipientWkList" :label="item.wkName" :value="item.wkNo" :key="item.wkNo"></el-option>
      </el-select>
      <el-button class="select-btn" type="primary" @click="showRecipientEdit">选择</el-button>
    </el-form-item>
    <el-form-item label-width="0" class="atb-no-margin">
      <div class="atb-text-right">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
        <!-- 取消 -->
        <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
      </div>
    </el-form-item>
  </el-form>
  <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" :showClose="true" :appendBody="true">
    <template slot="content">
      <component v-bind:is="dialogContent.componentName" :users="userData" :editData="EditRow" @updateUsers="updateUsers"></component>
    </template>
  </common-dialog>
</div>

</template>
<script>
import _ from 'lodash';
import XEUtils from 'xe-utils'
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
    UserEdit: () => import('./UserEdit'),
  },
  props: {
    // 编辑信息
    editData: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    //监听传入的信息，深拷贝新的数据，保证数据避免被污染
    editData: {
      handler: function(newValue){
        let editJson = JSON.parse(JSON.stringify(newValue || {}));
        this.editJson = editJson;
        this.cacheEditJson = JSON.parse(JSON.stringify(this.editJson));
        const wkList = editJson.wkList || [];
        const initRecipientWkList = editJson.recipientList || [];
        this.initWkList = wkList.map(item => {
          return {
            wkName: item.wkName,
            wkNo: item.wkNo,
          }
        });
        this.initRecipientWkList = initRecipientWkList.map(item => {
          return {
            wkName: item.wkName,
            wkNo: item.wkNo,
          }
        });
      },
      immediate: true
    }
  },
  data() {
    const validateDept = (rule, value, callback) => {
      if (!value && this.editJson.wkNos.length === 0) {
        return callback(new Error('"部门和人员"不能同时为空'));
      } else {
        this.$refs.editForm.clearValidate('wkNos');
      }
      callback();
    };
    const validatePerson = (rule, value, callback) => {
      if ((!value || value.length === 0) && !this.editJson.departNo) {
        return callback(new Error('"部门和人员"不能同时为空'));
      } else {
        this.$refs.editForm.clearValidate('departNo');
      }
      callback();
    };
    return {
      id: 'id',
      rules: {
        departNo: [
          { validator: validateDept, trigger: ['change', 'blur'] }
        ],
        wkNos: [
          { validator: validatePerson, trigger: ['change', 'blur'] }
        ],
        recipientWkNos: [
          { required: true, type: 'array', message: '消息提醒接收人必填', trigger: 'change' }
        ],
      },
      addApi: this.$api.Identity.deptNotification.create,
      editApi: this.$api.Identity.deptNotification.update,
      addMethod: 'post',
      editMethod: 'post',
      editJson: {},
      cacheEditJson: {},
      depData: [],
      seleterWkNameData: [],
      seleterReWkNameData: [],
      loading: false,
      isSave: false,
      isEdit: false,
      initWkList: [],
      initRecipientWkList: [],

      dialogContent: {

      },
      userData: [],
      type: 0,
    }
  },
  mounted() {
    if( this.editJson[this.id] ) {
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs['editForm'].clearValidate();
      })
    }
  },
  methods: {
    //取消操作
    cancel() {
      if(JSON.stringify(this.editJson) != JSON.stringify(this.cacheEditJson) && !this.isSave){
        this.$confirm('当前信息有数据变动，你是否确定要关闭 ?','提示',{
          confirmButtonText: '继续编辑',
          cancelButtonText: '确认关闭',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
          type: 'warning'
        }).then(()=>{}).catch(()=>{
          //取消编辑弹窗
          this.$parent.$parent.hide();
        })
      }else{
        //取消编辑弹窗
        this.$parent.$parent.hide();
      }
    },
    //提交操作
    submit() {
      //验证表单校验是否通过
      this.$refs['editForm'].validate(valid=>{
        //通过后提交数据
        if(valid){
          //判断是新增还是编辑操作
          var api = this.addApi;
          var apiMethod = this.addMethod;
          if(this.editJson[this.id]) {
            api = this.editApi;
            apiMethod = this.editMethod;
          }
          var params = this.resetSubmitParams(this.editJson);
          if(api)
            this.loading = true;
            //提交数据
            this.$ajax[apiMethod](api, params).then(response=>{
              if(response.code == this.$config.ResultCode.SUCCESS_CODE || !response.error){
                this.loading = false;

                //成功提示
                this.$message({
                  type: 'success',
                  message: this.successMsg || response.msg || this.$t('common.SubmitSuccess')
                });
                //标记是否已保存
                this.isSave = true;
                this.$emit('submitSuccess');
                //取消弹窗
                this.cancel();
              }
            }).catch(()=>{ this.loading = false });
        }
      })
    },
    resetSubmitParams(params){
      let sendParams = [];
      if (this.isEdit) {
        sendParams = {
          "groupId": params.id,
          "recipientNoList": params.recipientWkNos,
          "deptWkInfoList": []
        }
        if (params.departNo) {
          sendParams.deptWkInfoList.push({
            deptWkNoStr: params.departNo,
            dataType: 1,
          })
        }
        if (params.wkNos.length > 0) {
          sendParams.deptWkInfoList.push({
            deptWkNoStr: params.wkNos.join(','),
            dataType: 2,
          })
        }
      } else {
        sendParams = [];
        if (params.departNo) {
          sendParams.push({
            departNo: params.departNo,
            wkNos: null,
            recipientWkNos: params.recipientWkNos,
            dataType: 1,
          })
        }
        if (params.wkNos.length > 0) {
          sendParams.push({
            departNo: null,
            wkNos: params.wkNos,
            recipientWkNos: params.recipientWkNos,
            dataType: 2,
          })
        }
      }
      return sendParams;
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    showUserEdit(){
      this.userData = JSON.parse(JSON.stringify(this.initWkList));
      this.dialogContent = {
        title: '人员',
        componentName: 'UserEdit',
        width: '720px'
      }
      this.type = 1;
      this.$refs.commonDialog.show()
    },
    showRecipientEdit(){
      this.userData = JSON.parse(JSON.stringify(this.initRecipientWkList));
      this.dialogContent = {
        title: '消息提醒接收人',
        componentName: 'UserEdit',
        width: '720px'
      }
      this.type = 2;
      this.$refs.commonDialog.show()
    },
    updateUsers(list) {
      if (this.type === 1) {
        this.initWkList = list;
        this.editJson.wkNos = this.initWkList.map(item => item.wkNo);
      } else if (this.type === 2) {
        this.initRecipientWkList = list;
        this.editJson.recipientWkNos = this.initRecipientWkList.map(item => item.wkNo);
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.dept-notification-edit {
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
  ::v-deep .select-form-item {
    .el-form-item__content {
      display: flex;
    }
    .select-btn {
      margin-left: 10px;
      height: 40px;
    }
    .el-input__suffix {
      display: none;
    }
    // .el-select {
    //   max-height: 120px;
    //   overflow: auto;
    //   border: 1px solid #C0C4CC;
    //   border-radius: 4px;
    // }
    // .el-select__tags {
    //   padding: 10px 0;
    //   top: 0px;
    //   transform: translateY(0);
    // }
    // .el-input.is-disabled .el-input__inner {
    //   background-color: transparent;
    //   // border: none;
    // }
  }
}
</style>